export default __webpack_public_path__ + "static/media/certlayout.bc0817ee.png";